import Router from 'vue-router';

// 导入组件
import IndexPage from '/src/pages/pc/indexPage/indexPage.vue';
import productContent from '/src/pages/pc/productContent/productContent.vue'
import aboutUs from '/src/pages/pc/aboutUs/aboutUs.vue';
import newProductDetails from '/src/pages/pc/newProductDetils/newProductDetils.vue';
import bookNow from '/src/pages/pc/bookNow/bookNow.vue';
import accommodationsPage from '/src/pages/pc/experience/accommodationsPage.vue';
import trafficPage from '/src/pages/pc/experience/trafficPage.vue';
import activitiesPage from '/src/pages/pc/experience/activitiesPage.vue';
import servicesPage from '/src/pages/pc/experience/servicesPage.vue';
import navPage from '/src/pages/phone/navPage/navPage.vue';

// 配置路由
const router = new Router({
  mode: 'history',  // 使用历史模式
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: IndexPage,
    },
    {
      path: '/travel',
      name: 'productContent',
      component: productContent,
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
    },
    {
      path: '/moveNow',
      name: 'bookNow',
      component: bookNow,
    },
    {
      path: '/productDetails',
      name: 'newProductDetails',
      component: newProductDetails,
    },
    {
      path: '/experience/accommodations',
      name: 'accommodationsPage',
      component: accommodationsPage,
    },
    {
      path: '/experience/traffic',
      name: 'trafficPage',
      component: trafficPage,
    },
    {
      path: '/experience/activities',
      name: 'activitiesPage',
      component: activitiesPage,
    },
    {
      path: '/experience/services',
      name: 'servicesPage',
      component: servicesPage,
    },
    {
      path: '/navPage',
      name: 'navPage',
      component: navPage,
    },
  ],
  scrollBehavior() {
    // 每次跳转时，滚动到顶部
    return { x: 0, y: 0 };
  }
});
// 解决重复点击跳转报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
// router.beforeEach((to, from, next) => {
//   if (to.fullPath == from.fullPath) {
//     return;
//   }
//   next();
// });
// 路由全局后置守卫
// router.afterEach((to, from) => {
  // 在路由切换后执行，例如记录日志等操作
  // console.log(`Navigated to: ${to.path}`);
// });

export default router;
